import { render, staticRenderFns } from "./declarationDetails.vue?vue&type=template&id=12c23595&scoped=true"
import script from "./declarationDetails.vue?vue&type=script&lang=js"
export * from "./declarationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c23595",
  null
  
)

export default component.exports